// src/components/TeaserSection1.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { trackClickEvent } from "../utils/analytics";

import mediaServicesImg from "../assets/images/mediaservices.png";
import pistonTeaserImg from "../assets/images/pistonteaser.jpg";
import singleTurbineImg from "../assets/images/singleturbineteaser.jpg";

export default function TeaserSection2() {
  const navigate = useNavigate();

  const cards = [
    {
      title: "Services",
      img: mediaServicesImg,
      link: "/services",
      analyticsKey: "Teaser: Discover Services",
    },
    {
      title: "Pistons",
      img: pistonTeaserImg,
      link: "/pistons",
      analyticsKey: "Teaser: Discover Pistons",
    },
    {
      title: "Single Turbines",
      img: singleTurbineImg,
      link: "/turbines",
      analyticsKey: "Teaser: Discover Single Turbines",
    },
  ];

  const handleClick = (card) => {
    trackClickEvent(card.analyticsKey);
    navigate(card.link);
  };

  return (
    <section className="bg-black space-y-12 px-4 sm:px-6 md:px-8 lg:px-8">
      <div className="grid gap-6
                      grid-cols-1
                      lg:grid-cols-2
                      lg:gap-6">
        {/* ─── Top card full width ─── */}
        <div
          className="relative overflow-hidden rounded-md cursor-pointer group
                     lg:col-span-2
                     h-96 sm:h-[24rem] md:h-[30rem] lg:h-[36rem]"
          onClick={() => handleClick(cards[0])}
        >
          <img
            src={cards[0].img}
            alt={cards[0].title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/30 to-transparent" />
          <div className="absolute bottom-6 left-6">
            <h2 className="text-3xl font-heading font-semibold text-white">
              {cards[0].title}
            </h2>
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleClick(cards[0]);
              }}
              className="mt-6 inline-flex items-center gap-3
                         px-8 py-4 h-20 rounded-full
                         bg-white/10 hover:bg-white/20
                         text-white font-body font-semibold tracking-tight
                         backdrop-blur-md transition duration-300
                         border border-white/30 text-lg"
            >
              <span>Discover</span>
              <ArrowRight className="w-6 h-6 stroke-[1.5]" />
            </div>
          </div>
        </div>

        {/* ─── Bottom two cards side by side ─── */}
        {cards.slice(1).map((card) => (
          <div
            key={card.title}
            className="relative overflow-hidden rounded-md cursor-pointer group
                     h-96 sm:h-[24rem] md:h-[30rem] lg:h-[36rem]"
            onClick={() => handleClick(card)}
          >
            <img
              src={card.img}
              alt={card.title}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/30 to-transparent" />
            <div className="absolute bottom-6 left-6">
              <h2 className="text-3xl font-heading font-semibold text-white">
                {card.title}
              </h2>
              <div
                onClick={(e) => {
                  e.stopPropagation();
                  handleClick(card);
                }}
                className="mt-6 inline-flex items-center gap-3
                           px-8 py-4 h-20 rounded-full
                           bg-white/10 hover:bg-white/20
                           text-white font-body font-semibold tracking-tight
                           backdrop-blur-md transition duration-300
                           border border-white/30 text-lg"
              >
                <span>Discover</span>
                <ArrowRight className="w-6 h-6 stroke-[1.5]" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
